import SettingFrame from "../../../../components/@settings/SettingFrame"

import WhatsAppSetting from "../../../../components/@settings/whatsapp/WhatsAppSetting"

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function WhatsAppPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <WhatsAppSetting
                routeType={routeType}
            />
        </SettingFrame>
    )
}       